// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientInfo_root__w6L8d","info":"PatientInfo_info__1begl"};